import { render, staticRenderFns } from "./change_cat.vue?vue&type=template&id=61dd619a&"
import script from "./change_cat.vue?vue&type=script&lang=js&"
export * from "./change_cat.vue?vue&type=script&lang=js&"
import style0 from "./change_cat.vue?vue&type=style&index=0&id=61dd619a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports